module.exports = [{"type":"resource","resource":"stamina","value":10},{"type":"resource-max","resource":"stamina","value":10},{"type":"discover","location":"airport-gate"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/init-effects.json
// module id = 144
// module chunks = 0